<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <transition name="fade"
                mode="out-in">
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload

    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="scss">
html {
  width: 100%;
  height: 100%;
}

body {
  font-family: 'Microsoft Yahei';
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue